import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/community/guidelines/_components/CommunityGuidelinesContent.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")